import { render, staticRenderFns } from "./default_old.vue?vue&type=template&id=da712736&scoped=true"
import script from "./default_old.vue?vue&type=script&lang=js"
export * from "./default_old.vue?vue&type=script&lang=js"
import style0 from "./default_old.vue?vue&type=style&index=0&id=da712736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da712736",
  null
  
)

export default component.exports